import { api } from "@/auth/api";
import { settings } from "@/settings";
import store from "@/store";
import { Order } from "@/types";
import { deepClone, formatDateRecursively, getOperator, headers, setOtherFilters, unmountSelectFieldsV2, UON } from "@/utils";
import { buildBirthplace, handleOrganisationToSave, handlePersonToSave, handleRole } from "../orderOrch";
import { handleProfessionalToCreate } from "../../thirdOrchestration";

const odm_product = "odm-product";
const odm_simulation = "odm-simulation";
/**
 * Ajoute le username du vendeur (tiers SELLER) dans orderInfo, pour que les BR
 * d'éligibilité puissent l'identifier de façon fiable (orderParty.party.username).
 * Le compte utilisateur est relié au tiers par user_lease_forge_user.associated_party_resourceuid.
 */
async function withSellerUsername(order: any) {
    const copy = deepClone(order);
    const seller = copy?.orderParties?.find((p: any) => p.orderParty?.role?.resourceUid === 'SELLER');
    const partyUid = seller?.orderParty?.party?.resourceUid;
    if (!partyUid) return copy;
    try {
        const qc_header: any = { qc: { queryId: 'user-lease-forge-user', offset: 0, limit: 1, parameters: {} } };
        setOtherFilters([getOperator('user_lease_forge_user', 'associated_party_resourceuid', 'EQUAL', `'${partyUid}'`, 'associated_party_resourceuid')], qc_header);
        const res = await api().get(settings.api_query_url, { headers: headers({ qc: JSON.stringify(qc_header.qc) }) });
        const username = res.data?.[0]?.username;
        if (username) seller.orderParty.party.username = username;
    } catch (e) {
        console.error('withSellerUsername', e);
    }
    return copy;
}

export const getCommissionProductPack = async (payload: any) => {
    const baseUrl = `${settings.api_url}/${odm_product}/api/1/${odm_product}`
    return new Promise<any>(async (resolve, reject) => {
        try {

            const orderInfo = JSON.stringify(await withSellerUsername(payload))
            const body={context:"DISTRIBUTION",
            maxResults: 100,
            applicationName:"ORIGINATION",
            orderInfo
            }
            const result = await api().post(`${baseUrl}/product/` ,body)
            resolve(result.data)
        } catch (e) {
            reject(e)
        }
    });
}
export function removeBusinessData(payload:any) {
  if(payload){
    delete payload.businessData;
  // Parcourt récursivement toutes les propriétés
  for (const key in payload) {
    if (typeof payload[key] === 'object') {
      removeBusinessData(payload[key]);
    }
  }
}
}
export const getCommissionPackItems = async (payload: any,commissionProductPackUid:any) => {
    const baseUrl = `${settings.api_url}/${odm_product}/api/1/${odm_product}`
    return new Promise<any>(async (resolve, reject) => {
        try {
          delete payload.config
          removeBusinessData(payload)
            const orderInfo = JSON.stringify(payload)
            const body={context:"DISTRIBUTION",
            maxResults: 100,
            applicationName:"ORIGINATION",
            orderInfo
        }
            const result = await api().post(`${baseUrl}/commissionProductPack/`+commissionProductPackUid+'/packItems/' ,body)
            resolve(result.data)
        } catch (e) {
            reject(e)
        }
    });
}
export const calculationCommission = async (payload: any,packItems:any) => {
    const baseUrl = `${settings.api_url}/${odm_simulation}/api/1/${odm_simulation}`
    return new Promise<any>(async (resolve, reject) => {
        try {

            const orderInfo = JSON.stringify(payload)
            const items= []
            for(const item of packItems.items){
                item.accessoryName=item.name
                delete item.status
                delete item.qualification
                delete item.amountMin
                delete item.amountMax
                delete item.annualRateMin
                delete item.annualRateMax
                delete item.name
                item.objectType='odm.simulation.simulationaccessoryitem.commissionitem'
                item.productUid= item.resourceUid
                items.push(item)
            }
            

            const body={orderInfo,
                commissions:items
        }
            const result = await api().post(`${baseUrl}/simulation/commission/`,body)
            resolve(result.data)
        } catch (e) {
            reject(e)
        }
    });
}
export const UpdateOrderCommission = async (order: any,packItem:any,commissionProductPackUid:any) => {
    const Commission =await calculationCommission(order,packItem)
    console.log(Commission)
    const orderCommissions=[]
    for(let i=0;i<packItem.items.length;i++ ){
        let beneficiary
        const associatedParty = store.state.orderModule.order.orderParties.find((party:any)=>party.orderParty.role.resourceUid===packItem.items[i].beneficiaryRole)
        if(packItem.items[i].beneficiaryParty !== null){
          beneficiary = packItem.items[i].beneficiaryParty
        } else if (associatedParty) {
            beneficiary = {
              associatedParty : associatedParty,
              systemUid : "odm-order",
              objectType : "odm.order.commissionbeneficiary",
            }
        }
        const orderCommission={
            objectType: "odm.order.ordercommission",
            systemUid: "odm-order",
            label:packItem.items[i].name ,
            basisValue: Commission.commissions[i].basisValue,
            basis: packItem.items[i].basis,
            rate: Commission.commissions[i].rate,
            taxCode:packItem.items[i].tax ,
            taxValue: null,
            calculatedAmountWTax: Commission.commissions[i].calculatedAmount,
            calculatedAmountWoTax: null,
            accessoryProduct: {
                objectType: "odm.product.financingproductpackitem.accessoryproductitem.commissionproductitem.assetcommissionproductitem",
                systemUid: "odm-product",
                resourceUid: packItem.items[i].resourceUid
            },
            commissionType: packItem.items[i].commissionType,
            adjustAmount: {
                amount: 0,
                currency: "EUR",
            },
            commissionAmountWTax: null,
            commissionAmountWoTax: null,
            orderAccessoryCalculationMethodOption:{
                resourceUid: packItem.items[i].calculationMethodOption,
                objectType: "odm.order.orderaccessorycalculationmethodoption",
                systemUid: "odm-order"
            },
            orderAccessoryPaymentDatesOption: null,
            beneficiary: beneficiary,
            role:{
                id:packItem.items[i].beneficiaryRole,
                label: packItem.items[i].beneficiaryRole
            }
    
    }
    orderCommissions.push(orderCommission)
    }
    order.orderCommissions=orderCommissions
    order.commissionProductPack={
        objectType: "odm.product.productsummary",
        systemUid: "odm-product",
        resourceUid: commissionProductPackUid
      }

    return order
    
}

export const calculateOrderCommission = async (order?: Order) => {
  //     TODO remove mock
  return Promise.resolve([
    {
      beneficiary: "Vendeur",
      number: 1,
      type: "Véhicule",
      description: "Prime Fixe",
      calculationType: "Taux",
      rateType: "%",
      amount: 5000,
      result: "10%",
      revision: "5,00",
      commission: "50,00",
    },
    {
      beneficiary: "Vendeur",
      number: 2,
      type: "Véhicule",
      description: "Prime Fixe",
      calculationType: "Taux",
      rateType: "%",
      amount: 5000,
      result: "10%",
      revision: "5,00",
      commission: "50,00",
    },
    {
      beneficiary: "Vendeur",
      number: 2,
      type: "Véhicule",
      description: "Prime Fixe",
      calculationType: "Taux",
      rateType: "%",
      amount: 5000,
      result: "10%",
      revision: "5,00",
      commission: "50,00",
    },
    {
      beneficiary: "Vendeur",
      number: 2,
      type: "Véhicule",
      description: "Prime Fixe",
      calculationType: "Taux",
      rateType: "%",
      amount: 5000,
      result: "10%",
      revision: "5,00",
      commission: "50,00",
    },
    {
      beneficiary: "Intermediarie",
      number: 2,
      type: "Véhicule",
      description: "Prime Fixe",
      calculationType: "Taux",
      rateType: "%",
      amount: 5000,
      result: "10%",
      revision: "5,00",
      commission: "50,00",
    },
  ]);
};

export const getOrderCommissionTask = () => {
  return {
    resourceUid: null,
    objectType: "odm.workflow.taskdetailinfo",
    systemUid: "odm-workflow",
    businessData: null,
    daaq: "/COMPANY1/PEUGEOT/CONCESSION1/VENDOR1/",
    taskId: "a3c44076-e07f-11ee-be9e-36da1d89fc69",
    taskName: "Start Order",
    priority: 50,
    creationDate: "2024-03-12 14:48:50",
    dueDate: "2024-03-14 14:48:50",
    endDate: null,
    followUpDate: null,
    status: null,
    assignee: "Sales01 Sales01 ## Sales01",
    owner: null,
    candidateUser: null,
    candidateGroup: null,
    processDefinitionId: "OrderProcess:25:ee9a4d72-e071-11ee-be9e-36da1d89fc69",
    processInstanceId: "a3c3f226-e07f-11ee-be9e-36da1d89fc69",
    variables: {
      orderId: {
        type: "String",
        value: "65f06b47a3854e6402e5a564",
        valueInfo: {},
      },
      module: {
        type: "String",
        value: "Order",
        valueInfo: {},
      },
      associated_networks_id: {
        type: "String",
        value: "PEUGEOT",
        valueInfo: {},
      },
      orderStatus: {
        type: "String",
        value: "ORDER",
        valueInfo: {},
      },
      orderCreationDate: {
        type: "String",
        value: "12/03/2024",
        valueInfo: {},
      },
      customerRessourceUid: {
        type: "String",
        value: "ofit4rucSBaOoQS-h7Vglw",
        valueInfo: {},
      },
      customerName: {
        type: "String",
        value: "Yassine Deschamps ",
        valueInfo: {},
      },
      customerBirthDate: {
        type: "String",
        value: "04/03/1980",
        valueInfo: {},
      },
      associated_network_nodes_id: {
        type: "String",
        value: "Concessionnaire_1",
        valueInfo: {},
      },
      customerType: {
        type: "String",
        value: "person",
        valueInfo: {},
      },
      customerReference: {
        type: "String",
        value: "P001360",
        valueInfo: {},
      },
      orderReference: {
        type: "String",
        value: "TS014289",
        valueInfo: {},
      },
      applicationName: {
        type: "String",
        value: "TWDClientApp",
        valueInfo: {},
      },
    },
    executionId: "a3c41962-e07f-11ee-be9e-36da1d89fc69",
    parentTask: null,
    taskDefinition: "STEP_ORDER_COMMISSION",
    isLoading: true,
  };
};

export const getSubventionProductPack = async (payload: any) => {
  const baseUrl = `${settings.api_url}/${odm_product}/api/1/${odm_product}`
  return new Promise<any>(async (resolve, reject) => {
      try {

          const orderInfo = JSON.stringify(payload)
          const body={context:"SUBSIDY",
          maxResults: 100,
          applicationName:"ORIGINATION",
          orderInfo
          }
          const result = await api().post(`${baseUrl}/product/` ,body)
          resolve(result.data)

      } catch (e) {
          reject(e)
      }
  });
}


export const getSubventionProductPackItems = async (payload: any , option : string) => {
  const baseUrl = `${settings.api_url}/${odm_product}/api/1/${odm_product}`
  return new Promise<any>(async (resolve, reject) => {
      try {

          const orderInfo = JSON.stringify(payload)
          const body={context:"SUBSIDY",
          maxResults: 100,
          applicationName:"ORIGINATION",
          orderInfo
          }
          const result = await api().post(`${baseUrl}/subsidyProductPack/${option}/packItems/` ,body)
          resolve(result.data)

      } catch (e) {
          reject(e)
      }
  });
}

export async function refreshCommisions(){
const orderParties = store.state.orderPartyModule.orderParties
  const order = store.state.orderModule.order
if(order && order.commissionProductPack &&order.commissionProductPack.resourceUid){
    const handleOrderParties = handleOrderPartiesOrch(deepClone(orderParties))   
    order.orderParties=handleOrderParties
    const commissionProductPackUid = order.commissionProductPack.resourceUid
    const packItem =await getCommissionPackItems(order,commissionProductPackUid)
    const Commission =await calculationCommission(order,packItem)
    const orderCommissions=[]
    for(let i=0;i<packItem.items.length;i++ ){
        let beneficiary
        const associatedParty = store.state.orderModule.order.orderParties.find((party:any)=>party.orderParty.role.resourceUid===packItem.items[i].beneficiaryRole)
        if(packItem.items[i].beneficiaryParty !== null){
          beneficiary = packItem.items[i].beneficiaryParty
        } else if (associatedParty) {
            beneficiary = {
              associatedParty : associatedParty,
              systemUid : "odm-order",
              objectType : "odm.order.commissionbeneficiary",
            }
        }
        const orderCommission={
            objectType: "odm.order.ordercommission",
            systemUid: "odm-order",
            label:packItem.items[i].name ,
            basisValue: Commission.commissions[i].basisValue,
            basis: packItem.items[i].basis,
            rate: Commission.commissions[i].rate,
            taxCode:packItem.items[i].tax ,
            taxValue: null,
            calculatedAmountWTax: Commission.commissions[i].calculatedAmount,
            calculatedAmountWoTax: null,
            accessoryProduct: {
                objectType: "odm.product.financingproductpackitem.accessoryproductitem.commissionproductitem.assetcommissionproductitem",
                systemUid: "odm-product",
                resourceUid: packItem.items[i].resourceUid
            },
            commissionType: packItem.items[i].commissionType,
            adjustAmount: {
                amount: 0,
                currency: "EUR",
            },
            commissionAmountWTax: null,
            commissionAmountWoTax: null,
            orderAccessoryCalculationMethodOption:{
                resourceUid: packItem.items[i].calculationMethodOption,
                objectType: "odm.order.orderaccessorycalculationmethodoption",
                systemUid: "odm-order"
            },
            orderAccessoryPaymentDatesOption: null,
            beneficiary: beneficiary,
            role:{
                id:packItem.items[i].beneficiaryRole,
                label: packItem.items[i].beneficiaryRole
            }
    
    }
    orderCommissions.push(orderCommission)
    }
    order.orderCommissions=orderCommissions
    
  }
  return order  
}

const handleOrderPartiesOrch = (orderParties:any) => {
    const listOrderParties:any[]=[]
    for(const orderPartie of orderParties){
        const associtedPartie :any={
            objectType: "odm.order.orderassociatedparty",
            systemUid: "odm-order",
            orderParty:{
                objectType: "odm.order.orderparty",
                systemUid: "odm-order",
                role:{
                    objectType: "odm.order.orderpartyrole",
                    systemUid: "odm-order",
                    resourceUid:orderPartie.role_code
                },
                party:{},
                third:orderPartie.associatedParty.third
            }

        }
        if(orderPartie.associatedParty&&orderPartie.associatedParty.third&&orderPartie.associatedParty.third.person
            &&orderPartie.associatedParty.third.type&&orderPartie.associatedParty.third.type.id&&
            (orderPartie.associatedParty.third.type.id === "party-FrenchPerson" || 
            orderPartie.associatedParty.third.type.id ==="party-FrenchProfessional")
        ){
            const isPro=orderPartie.associatedParty.third.type.id ==="party-FrenchProfessional"

            unmountSelectFieldsV2(orderPartie.associatedParty.third.person, [
                "title",
                "nationality",
                "role",
                "status",
                "currentMaritalStatus",
                "currentMatrimonialRegime",
                "nature",
                "periodicity",
                "classifications",
                "gender",
                "birthplace",
                "addresses"
              ]);
              if(!(orderPartie.associatedParty.third.person.roles && orderPartie.associatedParty.third.person.roles.length>0)){
                orderPartie.associatedParty.third.person.roles=  handleRole(orderPartie.role_code)
              }
            unmountSelectFieldsV2(orderPartie.associatedParty.third.person.classifications, ["partyClass"]);
            orderPartie.associatedParty.third.person.birthplace= buildBirthplace(orderPartie.associatedParty.third.person.birthplace)
            if(isPro){
                const professional=handleProfessionalToCreate(orderPartie.associatedParty.third)
                orderPartie.associatedParty.third.person=professional
            }else{
                orderPartie.associatedParty.third.person.legalEntity=null 
            }
            const person =handlePersonToSave(orderPartie.associatedParty.third.person)
            if(isPro&&person.businessData){
                person.businessData.szTypeClient='PP'
            }
            person.objectType="odm.party.party.person.frenchperson"
            person.systemUid="odm-party"
            associtedPartie.orderParty.party={
                objectType: "odm.party.party.person.frenchperson",
                systemUid: "odm-party",
                rawData:person
            }
            associtedPartie.orderParty.third=orderPartie.associatedParty.third
            if(person.resourceUid){
                associtedPartie.orderParty.party.resourceUid=person.resourceUid
            }
            
        }
        if(orderPartie.associatedParty&&orderPartie.associatedParty.third&&orderPartie.associatedParty.third.organization
            &&orderPartie.associatedParty.third.type&&orderPartie.associatedParty.third.type.id&&
            orderPartie.associatedParty.third.type.id === "party-FrenchOrganization"
        ){
            unmountSelectFieldsV2(orderPartie.associatedParty.third.organization, [
                "legalCategory",
                "activitySector",
                "partyClass",
                "codeNACE",
                "role",
                "status",
                "contacts",
                "addresses",
                "correspondents",
                "financialExposures"
              ]);
              if(!(orderPartie.associatedParty.third.organization.roles && orderPartie.associatedParty.third.organization.roles.length>0)){
                orderPartie.associatedParty.third.organization.roles=  handleRole(orderPartie.role_code)
              }
              unmountSelectFieldsV2(orderPartie.associatedParty.third.organization.classifications, ["partyClass"]);
            const organization =handleOrganisationToSave(orderPartie.associatedParty.third.organization)
            organization.objectType ="odm.party.party.organization.frenchorganization"
            organization.systemUid= "odm-party"
            
            associtedPartie.orderParty.party={
                objectType: "odm.party.party.organization.frenchorganization",
                systemUid: "odm-party",
                rawData:organization
            }
            if(orderPartie.associatedParty.third.organization.resourceUid){
                associtedPartie.orderParty.party.resourceUid=orderPartie.associatedParty.third.organization.resourceUid
            }
            
        }
        if(orderPartie.resourceUid){
            associtedPartie.resourceUid=orderPartie.resourceUid
        }
        if(orderPartie.orderPartyResourceUid){
            associtedPartie.orderParty.resourceUid=orderPartie.orderPartyResourceUid
        }
        

        listOrderParties.push(associtedPartie)
    }
    return listOrderParties

}


export async function deleteOrderSubsidy(resourceUid: any) {
  let response: any;
  let error: any;
  try {
    response = await api().delete(`/${UON.SystemUid.odmOrder}/api/1/${UON.SystemUid.odmOrder}/ordersubsidy/${resourceUid}/`);

    console.info(`Entity deleted from resource ${UON.SystemUid.odmOrder}/ordersubsidy with resourceUid: ${resourceUid}`);
  }
  catch (e) {
    error = e
    console.error(`ERROR => ${error?.response?.data?.message?.returnMessage}`)
  }
  return { response, error }
}